import i18n from 'i18n';
import {
  ColDef
} from '@ag-grid-enterprise/all-modules';

export const sipPrefixColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('sipSetting.grid.code'),
    field: 'code',
    flex: 2,
    filter: 'agTextColumnFilter',
    editable: true,
    cellRenderer: 'codeCellRenderer',

  },
  {
    filter: false,
    cellClass: 'allowed-ips-update-table-center-cell',
    headerClass: 'allowed-ips-update-table-action-header',
    cellRenderer: 'actionCellRenderer',
  },
];

export default sipPrefixColumnDefs;
